import React from 'react';

import CSSModule from 'react-css-modules';
import { useNavigate } from 'react-router-dom';

import styles from './TermsOfService.module.scss';

const TERMS_OF_SERVICE_URL = process.env.REACT_APP_TERMS_OF_SERVICE_URL;

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div styleName="page">
      <div styleName="toolbar">
        <button type="button" styleName="back" onClick={() => navigate('/my-account')}>
          ← Back to account
        </button>
      </div>
      <iframe title="Terms of Service" src={TERMS_OF_SERVICE_URL} styleName="frame" />
    </div>
  );
};

export default CSSModule(TermsOfService, styles, { allowMultiple: true });